import React, { createContext } from 'react';
import { getFromAPI } from '../../../Utils/utils'; // Adjust the import path as needed

export const BranchAdminContext1 = createContext(null);
